export default __webpack_public_path__ + "static/spinner-cc2273324d24230c32202c8aa681e510.gif";